import * as React from "react";
import { Dialog, DialogContent, Box, Button, Typography } from "@mui/material";

const BiographyTips = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="biography-tips-dialog"
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: "#fff",
          p: { xs: 2, sm: 3 },
          borderRadius: 3,
          width: "100%",
          maxWidth: {
            xs: "90%",
            sm: 450,
            md: 550,
            lg: 640,
            xl: 720,
          },
        },
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        },
      }}
    >
      <DialogContent>
        <Box>
          <Typography
            id="biography-tips-dialog"
            variant="h5"
            sx={{
              color: "#2A4876",
              fontWeight: 600,
              textAlign: "center",
              fontSize: { xs: "20px", sm: "24px", lg: "28px" },
              mb: 2,
            }}
          >
            Tips
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: 14, sm: 15 },
              fontWeight: 400,
              lineHeight: 1.7,
              color: "#152134",
              mb: 3,
            }}
          >
            We encourage you to be yourself and share any information you'd like
            others to know about you when writing your bio. The prompts below
            are just suggestions to help you get started if you feel stuck—they
            are not mandatory.
            <br />
            <br />
            Share your personality and let others see the real you!
          </Typography>

          <Typography
            variant="subtitle1"
            sx={{ color: "#152134", fontWeight: 600, mb: 2 }}
          >
            Biography Prompts for Your Profile:
          </Typography>

          <Box component="ol" pl={3} sx={{ color: "#152134", mb: 3 }}>
            {[
              {
                label: "Introduction:",
                text: "Start with your name, general position, and what you're passionate about. Share your journey and tell us what sparked your interest in aviation!",
              },
              {
                label: "Professional Background:",
                text: "Provide a summary of key roles and professional accomplishments. Highlight how your current job or past experiences have shaped your career.",
              },
              {
                label: "Education & Training:",
                text: "Share your educational background and any specialized training you’ve completed.",
              },
              {
                label: "Skills and Strengths:",
                text: "Highlight key skills that define you and how they contribute to your professional and personal growth.",
              },
              {
                label: "Career & Personal Goals:",
                text: "Outline your short-term and long-term goals in aviation or personal development. If you are a mentee, share what you hope to achieve through mentorship. If you are a mentor, explain how you aim to support others.",
              },
              {
                label: "Mentorship Philosophy (For Mentors):",
                text: "Describe your approach to mentorship and what mentees can expect from you.",
              },
              {
                label: "Personal Interests:",
                text: "Tell us about your hobbies, friends, or family! This can help others connect with you on a personal level.",
              },
              {
                label: "Call to Action:",
                text: "Conclude with what you are looking for in a mentor or mentee and what you hope to gain or contribute through mentorship. Express why you're excited about this opportunity!",
              },
            ].map((item) => (
              <li key={item.label} style={{ marginBottom: "12px" }}>
                <strong>{item.label} </strong>
                {item.text}
              </li>
            ))}
          </Box>

          <Typography
            variant="subtitle1"
            sx={{ color: "#152134", fontWeight: 600, mb: 2 }}
          >
            Guiding Questions:
          </Typography>

          <Box component="ul" pl={3} sx={{ color: "#152134", mb: 3 }}>
            {[
              "What are you striving to accomplish in aviation?",
              "What are your passions and interests?",
              "What are some highlights of your professional journey?",
              "What do you enjoy doing in your spare time?",
            ].map((item) => (
              <li key={item} style={{ marginBottom: "8px" }}>
                {item}
              </li>
            ))}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 3,
            }}
          >
            <Button
              onClick={onClose}
              sx={{
                backgroundColor: "#2A4876",
                textTransform: "none",
                borderRadius: "50px",
                color: "#fff",
                fontWeight: 600,
                px: 5,
                py: 1.5,
                fontSize: { xs: 14, sm: 16 },
                "&:hover": {
                  backgroundColor: "#1d365a",
                },
              }}
            >
              Ok
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default BiographyTips;
